import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_ADMIN_PLAYERS_BONUSES = Symbol('admin.players-bonuses');

// Bonuses
export const ADMIN_PLAYERS_BONUSES_ADDITIONAL_ROUTE_NAME = Symbol('admin.players.bonuses.additional');
export const ADMIN_PLAYERS_BONUSES_LIST_ROUTE_NAME = Symbol('admin.players.bonuses.list');

export const PLAYERS_BONUSES_LIST_QUERY_KEY = 'players-bonuses-list';
export const PLAYERS_BONUSES_LIST_API_URL = 'admin/bonuses/list';

export const CHANGE_PLAYER_BONUS_MUTATION_KEY = 'change-player-bonus-status';
export const CHANGE_PLAYER_BONUS_API_URL = (bonusId: number): string => `admin/bonuses/${bonusId}`;

export const PLAYERS_BONUSES_PERMISSIONS = {
  PLAYERS_BONUSES_SHOW: new Permission(
    PermissionsList.admin.BONUSES_SHOW,
  ),
  PLAYERS_BONUSES_DELETE: new Permission(
    PermissionsList.admin.BONUSES_DELETE,
  ),
};
